import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyDpTu0WAyHBR9e1eiAfd9fdhpwZBOUnu6k",
    authDomain: "react-gisanim.firebaseapp.com",
    projectId: "react-gisanim",
    storageBucket: "react-gisanim.appspot.com",
    messagingSenderId: "852684174395",
    appId: "1:852684174395:web:218c52eea3e22248f8981e",
    measurementId: "G-7Y50FDHVN8"
};

export const firebaseApp = initializeApp(firebaseConfig);